import { apiFetch } from "./client.ts";

export interface Site {
  id: string;
  account_id: string;
  name: string;
  domain: string;
  city: string | null;
  timezone: string;
  locale: string;
  twilio_number_e164: string | null;
  settings: Record<string, unknown>;
  is_active: boolean;
  created_at: string;
}

export interface ApiKeyIssued {
  id: string;
  site_id: string;
  key: string;
  key_prefix: string;
  label: string | null;
}

export interface ApiKeyListItem {
  id: string;
  site_id: string;
  key_prefix: string;
  label: string | null;
  scopes: string[];
  created_at: string;
  revoked_at: string | null;
  last_used_at: string | null;
}

export const listSites = () => apiFetch<Site[]>("/sites");
export const createSite = (payload: Partial<Site>) =>
  apiFetch<Site>("/sites", { method: "POST", body: JSON.stringify(payload) });
export const updateSite = (id: string, patch: Partial<Site>) =>
  apiFetch<Site>(`/sites/${id}`, { method: "PATCH", body: JSON.stringify(patch) });
export const issueApiKey = (siteId: string, label?: string) =>
  apiFetch<ApiKeyIssued>(`/sites/${siteId}/api-keys${label ? `?label=${encodeURIComponent(label)}` : ""}`, {
    method: "POST",
  });
export const listApiKeys = (siteId: string) =>
  apiFetch<ApiKeyListItem[]>(`/sites/${siteId}/api-keys`);
export const revokeApiKey = (siteId: string, keyId: string) =>
  apiFetch<void>(`/sites/${siteId}/api-keys/${keyId}/revoke`, { method: "POST" });
export const rotateWebhookSecret = (siteId: string) =>
  apiFetch<{ webhook_secret: string }>(`/sites/${siteId}/rotate-webhook-secret`, { method: "POST" });
